<template>
    <div
        v-if="showBanner"
        class="tw-bg-cover tw-bg-center tw-bg-no-repeat tw-py-20"
        :style="{
            backgroundImage: `url(${bgImage})`,
        }">
        <div class="io-container tw-relative tw-my-0 tw-grid tw-grid-cols-1 tw-gap-y-8 lg:tw-grid-cols-12 tw-items-center">
            <div class="max-lg:tw-order-2 max-lg:tw-text-center lg:tw-col-span-7">
                <h2
                    class="tw-mb-6 max-lg:tw-mx-auto max-md:tw-text-2xl sm:tw-w-8/12 xl:tw-w-10/12"
                    v-html="banner.title"></h2>
                <p
                    v-if="banner.text"
                    class="tw-text-lg max-lg:tw-mx-auto sm:tw-w-8/12 xl:tw-w-10/12"
                    v-html="banner.text"></p>
                <div
                    v-if="banner.buttonUrl && banner.buttonText"
                    class="tw-flex tw-gap-6 max-lg:tw-justify-center tw-mt-8">
                    <v-btn
                        class="tw-h-12"
                        color="blue"
                        rounded="pill"
                        v-bind="urlProps(banner.buttonUrl)"
                        >{{ banner.buttonText }}</v-btn
                    >
                </div>
            </div>
            <div class="max-lg:tw-order-1 max-lg:tw-text-center lg:tw-col-span-5">
                <img
                    v-if="bannerImage"
                    alt=""
                    class="tw-h-full tw-w-full tw-object-contain tw-max-h-80"
                    :src="bannerImage" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { urlProps } from '@/composables/urlProps';
    import { useMedia } from '@/composables/useMedia';

    const props = defineProps<{
        banner: any;
    }>();

    const bgImage = computed(() => {
        if (!props.banner.background) return null;
        return useMedia(props.banner.background).original;
    });

    const bannerImage = computed(() => {
        if (!props.banner.image) return null;
        return useMedia(props.banner.image).original;
    });

    const showBanner = computed(() => {
        // if banner exists, has a title and button text, return true
        return props.banner && props.banner.title;
    });
</script>

<style scoped></style>
